"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialDefinition = void 0;
const zod_1 = require("zod");
const hex_string_1 = require("../hex-string");
exports.CredentialDefinition = zod_1.z.object({
    slug: zod_1.z.string(),
    ownerAddress: hex_string_1.HexString,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlZGVudGlhbC1kZWZpbml0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL2NyZWRlbnRpYWwtZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBdUI7QUFFdkIsOENBQXlDO0FBRTVCLFFBQUEsb0JBQW9CLEdBQUcsT0FBQyxDQUFDLE1BQU0sQ0FBQztJQUMzQyxJQUFJLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtJQUNoQixZQUFZLEVBQUUsc0JBQVM7Q0FDeEIsQ0FBQyxDQUFBIn0=